import React from 'react';

export default function SubmitButton({ buttonText, type = "button", width }) {
  return (
    <div>
      <button 
        type={type} 
        className={`flex   py-[10px] px-5 rounded-md justify-center items-center gap-2.5 bg-gradient-to-r from-[#2952F0] via-[#4268FF] to-[#113BE1] text-white text-base font-medium text-center mt-7 text-[0.890rem] sm:text-[1rem] ${width ? `w-${width}`: ''}`}
      >
        {buttonText}
      </button>
    </div>
  );
}
